module.exports = __webpack_public_path__ + "img/whyluckperms-1.10717222.png";